import type { ProductGallery } from "@core/schema/ProductGallery.js";
import type { MediaSrc } from "./common/MediaSrc.js";

export function getMediaSourceFromProductGallery(galleryItem: ProductGallery): MediaSrc {
	if (galleryItem.photo) {
		return galleryItem.photo;
	}
	if (galleryItem.youtube) {
		return { youtube: galleryItem.youtube };
	}
	throw new Error("Product gallery must have either a photo or youtube URL");
}
